import React from 'react';
import { ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/trackAddToCart';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
export function HeroSection() {
  return <section className="w-full overflow-hidden" style={{
    background: 'var(--bg-warm)'
  }} aria-label="Hero" data-id="element-146">
      <div className="max-w-2xl mx-auto px-4 pt-10 pb-12 md:pt-16 md:pb-20" data-id="element-147">
        <div className="flex flex-col items-center text-center" data-id="element-148">
          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-2 mb-5" data-id="element-149">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold" style={{
            background: 'var(--color-accent-light)',
            color: 'var(--color-accent)',
            border: '1px solid rgba(58,107,60,0.2)',
            fontFamily: 'var(--font-body)',
            letterSpacing: '0.02em'
          }} data-id="element-150">
              ✅ Compra Verificada
            </span>
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold" style={{
            background: 'var(--color-gold-light)',
            color: '#7A5C10',
            border: '1px solid rgba(184,146,42,0.25)',
            fontFamily: 'var(--font-body)',
            letterSpacing: '0.02em'
          }} data-id="element-151">
              ★★★★★
              <span className="ml-1" data-id="element-152">+500 familias</span>
            </span>
          </div>

          {/* Main headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl mb-4" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em',
          lineHeight: 1.1
        }} data-id="element-153">
            Resolvé{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-154">
              10 Días de Comida
            </span>{' '}
            en Solo{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-155">
              2 Horas
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg mb-7" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-secondary)',
          lineHeight: 1.75,
          fontWeight: 400,
          maxWidth: '520px'
        }} data-id="element-156">
            <em className="font-[400]" data-id="element-157">
              El{' '}
              <strong style={{
              fontWeight: 700,
              textDecoration: 'underline',
              textDecorationColor: 'var(--color-gold)',
              textUnderlineOffset: '3px',
              textDecorationThickness: '2px'
            }} data-id="element-158">
                sistema de 6 pasos
              </strong>{' '}
              para dejar de improvisar, eliminar el delivery por cansancio y
              tener el freezer lleno
            </em>{' '}
            —{' '}
            <strong style={{
            color: 'var(--text-primary)',
            fontWeight: 600
          }} data-id="element-159">
              sin vivir en la cocina.
            </strong>
          </p>

          {/* Hero image — full width, after subheadline */}
          <div className="w-full rounded-2xl overflow-hidden mb-8" style={{
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-md)'
        }} aria-label="Hero image" data-id="element-160">
            <img src="https://cdn.magicpatterns.com/uploads/avXfojrAUQ7PsUmUipPzNu/20260303_1146_Image_Generation_remix_01kjt2hag0fe6swnp6e4ws1vcz_(1).webp" alt="Sistema 10x2™ — El Método Express, Armado y Rotación, Guía Anti-Caos" className="w-full h-auto object-cover" style={{
            display: 'block'
          }} data-id="element-161" />
          </div>

          {/* Stats row */}
          <div className="flex flex-nowrap justify-center gap-2 sm:gap-3 mb-7 w-full" data-id="element-162">
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-163">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-164">
                4
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-165">
                Recetas Estratégicas
              </span>
            </div>
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-166">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-167">
                20
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-168">
                Porciones Listas
              </span>
            </div>
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-169">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-170">
                2 hs
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-171">
                De Cocina
              </span>
            </div>
            <div className="flex flex-col items-center px-3 sm:px-4 py-3 rounded-xl flex-1 min-w-0" style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm)'
          }} data-id="element-172">
              <span className="font-bold leading-none" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-primary)',
              fontSize: '1.75rem'
            }} data-id="element-173">
                10
              </span>
              <span className="text-[10px] sm:text-xs mt-1 text-center leading-tight" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-muted)',
              fontWeight: 500
            }} data-id="element-174">
                Días Resueltos
              </span>
            </div>
          </div>

          {/* CTA */}
          <a href={CART_URL} onClick={trackAddToCart} className="btn-cta btn-cta-pulse w-full text-base md:text-lg px-8 py-4 mb-4 rounded-xl flex justify-center" aria-label="Quiero mi sistema" data-id="element-175">
            QUIERO MI SISTEMA
            <ArrowRightIcon className="w-5 h-5 flex-shrink-0" data-id="element-176" />
          </a>

          {/* Micro-trust */}
          <p className="flex items-center justify-center gap-1.5 text-sm" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-muted)',
          fontWeight: 400
        }} data-id="element-177">
            <ShieldCheckIcon className="w-4 h-4 flex-shrink-0" style={{
            color: 'var(--color-accent)'
          }} data-id="element-178" />
            Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}